import { useEffect, useState } from "react";
import { CUSTOMER_LEVEL_TABLE } from "../../utils/dataconstants";
import { Table } from "rsuite";
import { useGetForecastCustomerLevelData } from "../../services/redux/hooks/useForecast";
import { useSelector } from "react-redux";
import { IRoot } from "../../services/interface/IHome";
import { formatNumber } from "../../utils/formatter";

const {Cell, HeaderCell, Column} = Table;

const CustomerDataTable=(props:any)=>{

    const {SKUl} = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [customerTableData, setCustomerTableData] = useState([]);
    const windowSize = useSelector((state:IRoot)=>state.filter.windowSize);
    const {mutate,isError,isSuccess,isLoading,data:customerData} = useGetForecastCustomerLevelData();

    useEffect(()=>{
        mutate({
            "skul": SKUl
        });
    },[SKUl]);  

    useEffect(()=>{
        setLoading(true);
        if(customerData){
            setCustomerTableData(customerData?.data);
            setLoading(false);
        }
    },[customerData])

    const CustomCell = ({ rowData, dataKey, ...props }: any) => {
        return <Cell {...props}>
            {["Customer_Number"].includes(dataKey) ? rowData[dataKey] : formatNumber(rowData[dataKey])}
        </Cell>
    }

    return <div className="flex flex-col">
        <Table
            loading={loading}
            height={windowSize?.width / 4}
            bordered
            data={loading ? [] : customerTableData}
            headerHeight={50}
            cellBordered
            rowClassName={(rowData, rowIndex) => {
                return rowIndex % 2 === 0 ? 'db-tablebg' : '';
            }}
        >
            {CUSTOMER_LEVEL_TABLE.map((value,index)=>{
                return <Column key={value.key} flexGrow={1}>
                    <HeaderCell style={{ textWrap:"wrap"}} className="font-bold">{value.label}</HeaderCell>
                    <CustomCell dataKey={value.key}></CustomCell>
                </Column>
            })}
        </Table>
    </div>
}

export default CustomerDataTable;